import EnumObject from '@/domain/enum-object.entity';

export default class PaymentsDetailed {
  line: number;

  id: string;

  dueAt: string;

  paidAt: string;

  value: string;

  paidValue: string;

  status: EnumObject;

  constructor(obj: any) {
    this.line = obj.line || '';
    this.id = obj.id || '';
    this.dueAt = obj.dueAt || '';
    this.paidAt = obj.paidAt || '';
    this.value = obj.value || '';
    this.paidValue = obj.paidValue || '';
    this.status = EnumObject.of(obj.status) || {};
  }

  public static of(obj: any = {}): PaymentsDetailed {
    return new PaymentsDetailed(obj);
  }

  public static ofList(obj: any[]): PaymentsDetailed[] {
    return obj.map(this.of)
  }
}
